import React from 'react'
import Player from './Player'
import Parser from 'html-react-parser'
import DOMPurify from 'dompurify'
import { AnswerType } from '../../Show'
import { formatDate, formatRelative } from '~/utils/dateFns'

type Props = {
  item: AnswerType
}

const Content: React.FC<Props> = ({ item }) => {
  const content = DOMPurify.sanitize(item.content)
  // .replace(/\n\n/g, '<br/>')

  if (item.infolineCall) {
    return (
      <>
        <p>{Parser(content)}</p>

        {item.infolineCall.answered ? (
          <Player item={item} />
        ) : (
          <>
            {Parser(intl.formatMessage({ id: 'ticket / call / not respond' }))}
          </>
        )}
      </>
    )
  }

  if (item.editedData) {
    return (
      <>
        {Parser(
          item.editedData.name == 'category'
            ? intl.formatMessage({
                id: 'ticket / answer / log / category',
              })
            : item.editedData.name == 'subcategory'
            ? intl.formatMessage({
                id: 'ticket / answer / log / subcategory',
              })
            : item.editedData.name == 'client'
            ? intl.formatMessage({
                id: 'ticket / answer / log / client',
              })
            : item.editedData.name == 'deadline'
            ? intl.formatMessage({
                id: 'ticket / answer / log / deadline',
              })
            : ''
        ) +
          (item.editedData.value.old
            ? ' ' +
              Parser(intl.formatMessage({ id: 'ticket / answer / log / from' }))
            : '') +
          (item.editedData.value.old ? ' ' : '') +
          (item.editedData.value.old ? item.editedData.value.old : '') +
          ' ' +
          Parser(intl.formatMessage({ id: 'ticket / answer / log / to' })) +
          ' ' +
          item.editedData.value.new}
      </>
    )
  }

  if (item.chat) {
    return (
      <>
        <p>{Parser(content)}</p>

        <span>
          {Parser(intl.formatMessage({ id: 'ticket / answer / chat' }))} (
          {formatDate(new Date(item.chat.created), 'P')})
        </span>
      </>
    )
  }

  return <>{Parser(content)}</>
}

export default Content
